__turbopack_context__.v({
  "body": "_7dj2Fa_body",
  "description": "_7dj2Fa_description",
  "error": "_7dj2Fa_error",
  "icon": "_7dj2Fa_icon",
  "inner": "_7dj2Fa_inner",
  "label": "_7dj2Fa_label",
  "labelWrapper": "_7dj2Fa_labelWrapper",
  "radio": "_7dj2Fa_radio",
  "root": "_7dj2Fa_root",
});
